// HomeOrDashboard, Roteador inteligente da rota "/".
//
// • Anônimo  → renderiza <Home/> (landing pastoral atual).
// • Logado (comum OU admin) → renderiza <DashboardLogado/>.
//   Admin NÃO é redirecionado automaticamente: o painel administrativo é
//   acessado somente via /admin ou pelo item "Painel Admin" do menu (FASE 2).
//
// Mantém o tree mounted para qualquer estado de checking, exibe um placeholder
// curtinho enquanto o AuthContext resolve a sessão (evita flash da Home p/
// usuários autenticados em load frio).
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/authContext";
import Home from "./Home";
import DashboardLogado from "./DashboardLogado";

export default function HomeOrDashboard() {
  const { isChecking, isAuthenticated, isAdmin, user } = useAuth();
  if (isChecking) {
    return (
      <div
        className="min-h-[40vh] flex items-center justify-center section-padding"
        data-testid="home-checking"
      >
        <p className="text-navy/55 text-sm uppercase tracking-widest">
          Carregando…
        </p>
      </div>
    );
  }
  if (isAuthenticated) {
    // Onboarding gate apenas para usuário comum; admin nunca é desviado.
    if (!user?.spiritual_profile && !isAdmin) {
      return <Navigate to="/bem-vindo?next=%2F" replace />;
    }
    return <DashboardLogado />;
  }
  return <Home />;
}
